export class TipocambiomastPk {
    monedacodigo: string;
    monedacambiocodigo: string;
    fechacambio: Date;

}
export class Tipocambiomast {
    pk: TipocambiomastPk;
    constructor() {
        this.pk = new TipocambiomastPk();
    }
    fechacambiostring: string;
    factor: number;
    factorcompra: number;
    factorventa: number;
    factorpromedio: number;
    factorcompraafp: number;
    factorventaafp: number;
    factorcomprasbs: number;
    factorventasbs: number;
    valorcuota: number;
    tasatamex: number;
    tasatamn: number;
    tasaanualtamex: number;
    tasaanualtamn: number;
    estado: string;
    ultimafechamodif: Date;
    ultimousuario: string;
    companiacodigo: string;
    factorcobranzaventa: number;
}